import React from 'react';
import {SafeAreaView, View, StyleSheet, Dimensions} from 'react-native';

const Layout = ({header, footer, children}) => {
  return (
    <SafeAreaView style={styles.wrapper}>
      <View style={styles.header}>{header}</View>
      <View style={styles.content}>{children}</View>
      <View style={styles.footer}>{footer}</View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
  },
  header: {},
  content: {
    flex: 1,
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    padding: 10,
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default Layout;
